import 'whatwg-fetch';

export function getUserId() {
  return request('user', {
    property_id: process.env.REACT_APP_PROPERTY_ID,
    url: document.location.href
  })
    .then(response => {
      return response.data.user_id;
    })
    .catch(error => {
      throw new Error(error);
    });
}
//
export function logEvent(
  userId,
  value,
  correct = null,
  attempt = null,
  feedback = null,
  score = null
) {
  request('event', {
    property_id: process.env.REACT_APP_PROPERTY_ID,
    user_id: userId,
    url: document.location.href,
    value,
    correct,
    attempt,
    feedback,
    score
  });
}

function parseJson(response) {
  return response.json();
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  throw new Error(response.statusText);
}

function request(endpoint, data) {
  return fetch(`//cepdata.frb.io/api/v2/${endpoint}`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })
    .then(checkStatus)
    .then(parseJson)
    .catch(error => {
      throw new Error(error);
    });
}



// WEBPACK FOOTER //
// ../core/src/utils/logging.js